import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { useAuth } from "../../Context/AuthContext";
import { ChangeOfAddressType } from "../../constants";
import { CheckPoBox } from "../../Layout/Common/common";
import { axiosInstance } from "../../axios/axiosInstance";

export const CouponPopup = ({ handleUpdateCoupon }) => {
  const [promoCode, setPromoCode] = useState("");
  const [checkedPromo, setCheckedPromo] = useState(false);
  const { userId } = useAuth();
  const [promocodeResponse, setPromocodeResponse] = useState(null);

  const { shippingAddress, CartItem, addressType } = useContext(GlobalContext);
  useEffect(() => {}, []);

  const handleOnChange = (e) => {
    setPromoCode(e.target.value);
  };
  const handleApplyPromoCode = (e) => {
    setCheckedPromo(e.target.checked);
  };

  const handleCheckPromoCode = () => {
    if (!promoCode) return false;
    var data = {
      tbpromocode: promoCode,
      userId: String(userId),
      IsDropShipment: ChangeOfAddressType.dropShippment == addressType,
      hfchangeofaddress: ChangeOfAddressType.changeOfAddress == addressType,
      hfshipcode: shippingAddress.shipZip,
      postcode: shippingAddress.shipZip,
      suburb: shippingAddress.shipCity,
      addressLine1: shippingAddress.shipAddress1,
      addressLine2: shippingAddress.shipAddress2,
      ispobox: CheckPoBox(shippingAddress.shipAddress1 + shippingAddress.shipAddress2),
      shipAddress: shippingAddress,
    };

    axiosInstance
      .post("Shipping/CheckPromoCode", data)
      .then((response) => {
        if (response.data) {
          setPromocodeResponse(response.data);
        }
      })
      .catch((error) => console.log("GetBillInfo", error.message));
  };

  return (
    <div
      className="modal fade"
      id="addCoupon"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-animate-center modal-dialog-coupon">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              Apply Coupon
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          {/* Modal body */}
          <div className="modal-body modal-body-coupon">
            <div className="coupon-search">
              <input
                type="text"
                id="coupon-search"
                className="form-control"
                placeholder="Enter Coupon Code"
                value={promoCode}
                onChange={handleOnChange}
              />
              <div className="button-effect">
                <button type="submit" onClick={handleCheckPromoCode} className="btn btn-products btn-addcart">
                  Check
                </button>
              </div>
            </div>
            <p>Availablity of the coupon in the list depends on the items added on the cart.</p>

            {promocodeResponse && !promocodeResponse.shipcode ? (
              <div className="available-coupons-content">
                <div className="coupon-info text-danger form-validation-message">{promocodeResponse.value}</div>
              </div>
            ) : (
              promocodeResponse &&
              promocodeResponse.shipcode != "" && (
                <div className="available-coupons">
                  <h6>Coupons</h6>
                  <div className="available-coupons-list">
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="availableCoupons"
                        id="availableCoupons1"
                        onChange={handleApplyPromoCode}
                      />
                    </div>
                    <div className="available-coupons-content">
                      <p className="coupon-text">{promocodeResponse.shipcode}</p>
                      {/* <div className="coupon-saved">You Save 30%</div> */}
                      <div className="coupon-info">
                        Availablity of the coupon in the list depends on the items added on the cart.
                      </div>
                      <div className="coupon-date">
                        <p>
                          Valid till :<span>{promocodeResponse.validUpto}</span>
                        </p>
                        {/* <p>
                        Max Discount : <span>$30</span>
                      </p> */}
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
          {/* Modal body */}
          <div className="modal-footer coupon-footer">
            {/* button */}
            <div className="coupon-max">
              {/* <div className="max-saving">Max Saving</div>
              <p>$30</p> */}
            </div>
            <div className="button-effect apply-coupon-btn">
              <button
                type="button"
                onClick={() => {
                  handleUpdateCoupon(promocodeResponse);
                }}
                className="btn btn-products btn-addcart"
                data-bs-dismiss="modal"
                disabled={!checkedPromo}
              >
                Apply Coupon
              </button>
            </div>
            {/* button */}
          </div>
        </div>
      </div>
    </div>
  );
};
